/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { FormStateProjectProfile } from "../types/ProfileTypes";

type PaginationType= {
    total: number
    page: number
    limit: number
    pages: number
    size?:number
    keyword:string
}
type Response = {
  payload: FormStateProjectProfile[];
  pagination_data: PaginationType;
};

export function useProjectList(params:{
    page: number,
    limit: number,
    size: number,
    status_project?: number
}) {

    const defaultPagination = {
        total: 0,
        page: 1,
        size: 10,
        pages: 1,
        keyword:'',
        limit:10,
    }
    const api = useApi();
    const [data, setData] = useState<FormStateProjectProfile[]>([]);
    const [paginationData, setPagination] = useState<PaginationType>(defaultPagination);
    const [isLoading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    const fetchData = () => {
        setLoading(true);

        api
        .get("project/get_data_project_profile",{params})
        .then((res: SuccessFetch<Response>) => {
            const data = res.data.payload ?? [];
            setData(data);
            setPagination({
                total:res.data.pagination_data.total,   
                page:res.data.pagination_data.page,
                pages:res.data.pagination_data.pages,
                size:res.data.pagination_data.size,
                limit:params.limit,   
                keyword:''      
            })
        })
        .catch(() => setData([]))
        .finally(() => setLoading(false));
    };

    const refetch = () => fetchData();

    useEffect(() => {
        if (hasFetched.current) return; // tidak fetch ulang
        hasFetched.current = true;
        fetchData();

        return () => {
            setData([]);
        };
        // eslint-disable-next-line
    }, []);

    return {
        data,
        isLoading,
        refetch,
        paginationData,
    };
}
